import styled from 'styled-components';
import NotificationsBar from './NotificationsBar';
import { colorSchema, media } from 'utils/style';

export default styled(NotificationsBar)`
  margin: 0 -1rem;
  ${media.greaterThan('tablet')`
    margin: 0;
  `}
  .notifications-bar {
    background-color: ${colorSchema('grey700')};
    border-top: 1px solid ${colorSchema('grey900')};
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;

    &__label {
      color: white;
      font-weight: bold;
      line-height: 4rem;
    }

    &__button {
      border: 0;
      background: none;
      cursor: pointer;
      color: ${colorSchema('white')};

      &--inline {
        font-weight: bold;
        text-decoration: underline;
      }
    }

    &__close {
      align-self: center;
      margin-right: 2rem;
      position: absolute;
      right: 0;

      svg {
        fill: ${colorSchema('white')};
      }
    }
  }
`;
